import { sendMessageToOrion, reviewDocument } from "../../services/agent.service";
import { ASK_ORION_ACTIONS } from "../slices/askOrion.slice";

export const sendMessageThunk = (params: {
  message: string;
  agent?: string;
}) => {
  return async (dispatch: any, getState: any) => {
    try {
      // Add user message first
      dispatch({
        type: ASK_ORION_ACTIONS.ADD_USER_MESSAGE,
        payload: params.message,
      });

      // Show loading
      dispatch({
        type: ASK_ORION_ACTIONS.SEND_MESSAGE_REQUEST,
      });

      // Get session_id from state
      const state = getState();
      const sessionId = state?.rootReducer?.askOrionReducer?.sessionId;

      // Prepare request payload
      const requestPayload: {
        session_id?: string;
        agent: string;
        message: string;
      } = {
        agent: params.agent || "sourcing_info_agent",
        message: params.message,
      };

      // Add session_id only if it exists
      if (sessionId) {
        requestPayload.session_id = sessionId;
      }

      // Make API call
      const response = await sendMessageToOrion(requestPayload);

      // Dispatch success with response
      dispatch({
        type: ASK_ORION_ACTIONS.SEND_MESSAGE_SUCCESS,
        payload: response,
      });

      return response;
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.status_message ||
        error?.message ||
        "Failed to send message";

      dispatch({
        type: ASK_ORION_ACTIONS.SEND_MESSAGE_FAILURE,
        payload: errorMessage,
      });

      throw error;
    }
  };
};

export const resetChatThunk = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: ASK_ORION_ACTIONS.RESET_CHAT,
      });
    } catch (error) {
      console.error("Error resetting chat:", error);
    }
  };
};

export const setSessionIdThunk = (sessionId: string) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: ASK_ORION_ACTIONS.SET_SESSION_ID,
        payload: sessionId,
      });
    } catch (error) {
      console.error("Error setting session ID:", error);
    }
  };
};

export const reviewDocumentThunk = (params: { doc_id: string; tab?: string }) => {
  return async (dispatch: any) => {
    try {
      // Show loading
      dispatch({
        type: ASK_ORION_ACTIONS.REVIEW_DOCUMENT_REQUEST,
      });

      // Make first API call to review document
      const response = await reviewDocument(params);

      // Dispatch success with first response
      dispatch({
        type: ASK_ORION_ACTIONS.REVIEW_DOCUMENT_SUCCESS,
        payload: response,
      });

      // Chain second API call if first one is successful
      if (response?.status && response?.doc_details?.drive_details?.reviewed_file_id) {
        const reviewedFileId = response.doc_details.drive_details.reviewed_file_id;
        
        // Import and call getCommentsWithIdService
        const { getCommentsWithIdService } = await import(
          "../../services/common.service"
        );
        // This call is part of the workbench document review flow — include the GSA feature flag
        const metaResponse = await getCommentsWithIdService(reviewedFileId, "gsa");
        
        // Dispatch action to store meta data
        dispatch({
          type: ASK_ORION_ACTIONS.SET_GOOGLE_DOC_META,
          payload: metaResponse,
        });
        
        console.log("Google Doc Meta Response:", metaResponse);
      }

      return response;
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.status_message ||
        error?.message ||
        "Failed to review document";

      dispatch({
        type: ASK_ORION_ACTIONS.REVIEW_DOCUMENT_FAILURE,
        payload: errorMessage,
      });

      throw error;
    }
  };
};
